import { Tag } from "components/styleguide";
import PropTypes from "prop-types";
import React, { memo, useMemo } from "react";
import { useTranslation } from "react-i18next";

import QuestionnaireStatusClass from "../../../../../backend-models/questionnaireStatus";

const QuestionnaireStatus = ({ value }) => {
  const { t } = useTranslation();
  const status = useMemo(() => new QuestionnaireStatusClass(value), [value]);
  const statusLabel = status.toString();
  const text = statusLabel ? t(statusLabel) : t("unknownStatus");

  /**
   * @type {'green'|'red'|undefined}
   */
  const color = useMemo(() => {
    if (status.isOpen) {
      return "green";
    }

    if (status.isDraft) {
      return "red";
    }

    return undefined;
  }, [status]);

  return <Tag color={color}>{text}</Tag>;
};

QuestionnaireStatus.propTypes = {
  value: PropTypes.oneOf(QuestionnaireStatusClass.VALUES),
};

export default memo(QuestionnaireStatus);
